import React from 'react'
import '../App.css'
import Navbar from '../components/navbar.js'
import Footer from '../components/footer.js'
import inside from '../inails&spa-photo/output6.webp'
// import outside from '../inails&spa-photo/outside1.jpeg'
// import outside2 from '../inails&spa-photo/outside2.jpeg'
const about = () => {
  document.title = "About Us | iNails & Spa";
  return (
    <>
      <Navbar />
      <div className="about">
        <div className="about-content">
          <div className='about-content-left'>
            <img src={inside} alt="inside" loading="lazy"/>
          </div>
          <div className='about-content-right'>
            <div className ='title about-title'>
              <h1><span className="font-letter">A</span>bout <span className="font-letter">U</span>s</h1>
            </div>
            <span>
              Imagine a day in which you are the focus of all day full of attention, in which personalized pampering and your satisfaction are the only things that matter. A day in which your smallest creature comforts are of the utmost importance, and the ultimate goal is to make you look and feel wonderful. 
            </span>
            <br/>
            <span>
              We at iNails & Spa take great pride in offering you the finest and most individualized concepts in nail designs, facials, spa treatments, and body waxing. Our staff is highly trained and educated in the most advanced techniques and services. Come in and experience our personal approach — where beauty meets relaxation. As always, we look forward to serving you and making your day extraordinary.
            </span>
            <br/>
            <span>
              We are a team of passionate professionals dedicated to innovation, integrity, and excellence. By working collaboratively, we ensure every service is executed with precision and care. Customer satisfaction is at the heart of everything we do, and we strive to build long-lasting relationships with our clients.
            </span>
            <br/>
            <span>
              Come and experience where beauty meets relaxation. We look forward to making your day extraordinary!
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default about